window.ckCatalog = window.ckCatalog || {};

/**** CART MODEL ***/
window.ckCatalog.cart = (function () {
  let _private = {};
  _private.cartData = {};
  _private.cartData.items = {};

  _private.getCart = function (cartType) {
    let cartUrl = cartType === 'sell-cart' ? '/api/sellcart' : '/api/cart';
    cartUrl = cartUrl + '?v=' + (new Date().getTime()).toString(24);
    let xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        try {
          cartData = JSON.parse(this.responseText);
        } catch (e) {
          $(document).trigger('notify.ck', {
            message: "There was a problem loading your cart. Please refresh the page before adding items to your cart.",
            severity: "warn"
          });
        }
        _private.updateCart(cartData);
      }
    };
    xhttp.open("GET", cartUrl, true);
    xhttp.send();
  };

  _private.updateCart = function (cartData) {
    let cart = cartData.cart || cartData;
    let lineitems = cart.lineitems || [];
    let newItems = {};

    for (let cartItemCount = 0; cartItemCount < lineitems.length; cartItemCount++) {
      let item = lineitems[cartItemCount];
      //if we have something that's been removed by setting to 0, set parent qty to 0
      if (item.product_id == cartData.id && cartData.qty == 0) {
        item.touched = true;
        item.qty = 0;
      } else {
        item.touched = (item.product_id == cartData.id);
        let key = item.id + ((typeof item.style == 'string' && item.style.length > 0) ? ('-' + item.style) : '');
        newItems[key] = item;
      }

      if (typeof cartData.qty !== undefined && cartData.qty === 0) {
        /*
         * When we have a removal, set the cartData.fullItems property.
         * This data includes the item that was removed, so the add to cart forms can be aware of the change.
         */
        _private.cartData.fullItems = _.map(_private.cartData.items, function (item) {
          if (cartData.id == item.product_id) {
            item.touched = true;
            item.qty = 0;
          }
          return item;
        });
      }
    }

    // Replace the previous cart items with the new ones
    _private.cartData.items = newItems;

    $(document).trigger('cartUpdated.ck',[_private.cartData]);

    // If the cartData.fullItems property was present, delete it; we only wanted it while the event propagated
    delete _private.cartData.fullItems;
  };

  //onload
  $(function () {

    $(document).on('updateCart.ck', function (e, cartData) { //cartData for updateCart
      _private.updateCart(cartData);
    });

    let cartType = $('body').hasClass('purchasing') ? 'sell-cart' : 'buy-cart';
    _private.getCart(cartType);

  });

  //public interface returns a deep copy of _private.cartData
  return function () {
    return $.extend(true, {}, _private.cartData);
  };

})();
